<template>
  <div class="divIndexCategories">
    <grid
      class="grid"
      :title="$t('grid.TitleCategory')"
      :headers="headers"
      controller
      readAll="Request/GetCategories"
      :disableEdit="true"
      :disableDelete="true"
      :ExportExcel="true"
      :ExportExcelLabel="$t('grid.ExportExcelCategory')"
      :CanCreate="true"
      :ShowMenu="true"
      createComponentRoute="ConfigEdit"
      :refresh="this.$store.getters.GET_reloadPage"
      :showFooter="false"
      :canExpand="false"
      :hideColumns="[]"
      searchFields="Name,Description,CountryPenalty"
      :exportHeaders="exportHeaders"
      :AddItem="$t('ContextMenu.AddCategory')"
      EditRoute="CategoriesEdit"
      :DefaultSorting="true"
      defaultColSorting="name"
      :deafaultDescSorting="false"
    >
      <template v-slot:default="child">
        <li @click="edit(child)" class="li-nobullets contextMenu">
          <span>Edit</span>
        </li>
      </template>
    </grid>
  </div>
</template>
<script>
import loading from "../../components/loadingComponent.vue";
import grid from "../../components/gridComponent.vue";
import { Trans } from "@/plugins/Translation";
import IMApi from "../../api/IM/IMApi.js";

export default {
  components: {
    grid,
    loading,
  },

  data() {
    return {
      headers: [
        {
          text: Trans.i18n.t("grid.Columns.Id"),
          value: "id",
          width: "7%",
        },
        {
          text: Trans.i18n.t("grid.Columns.Name"),
          value: "name",
          width: "15%",
        },
        {
          text: Trans.i18n.t("grid.Columns.NameEn"),
          value: "nameEn",
          width: "15%",
        },
        {
          text: Trans.i18n.t("grid.Columns.Description"),
          value: "description",
          width: "15%",
        },
        {
          text: Trans.i18n.t("grid.Columns.DescriptionEn"),
          value: "descriptionEn",
          width: "15%",
        },
        {
          text: Trans.i18n.t("grid.Columns.IsRisk"),
          value: "isRisk",
          width: "15%",
        },
        {
          text: Trans.i18n.t("grid.Columns.CountryPenalty"),
          value: "countryPenalty",
          width: "10%",
        },
        {
          text: Trans.i18n.t("grid.Columns.Enabled"),
          value: "enable",
          width: "8%",
        },
        { text: "", value: "edit", width: "70" },
      ],
      exportHeaders: [
        {
          text: Trans.i18n.t("grid.Columns.Id"),
          value: "id",
        },
        {
          text: Trans.i18n.t("grid.Columns.Name"),
          value: "name",
        },
        {
          text: Trans.i18n.t("grid.Columns.NameEn"),
          value: "nameEn",
        },
        {
          text: Trans.i18n.t("grid.Columns.Description"),
          value: "description",
        },
        {
          text: Trans.i18n.t("grid.Columns.DescriptionEn"),
          value: "descriptionEn",
        },
        {
          text: Trans.i18n.t("grid.Columns.IsRisk"),
          value: "isRisk",
        },
        {
          text: Trans.i18n.t("grid.Columns.CountryPenalty"),
          value: "countryPenalty",
        },
        {
          text: Trans.i18n.t("grid.Columns.Enabled"),
          value: "enable",
        },
      ],
      filters: {},
      localStorageItemGridId: "app_savedSearchParamsGrid",
    };
  },

  async created() {
    let user = this.$GAUserAuth.user;

    // only ad user can be access
    let aduserInfo_res = await IMApi.GetADUserInformationByUsername(
      this.$GAUserAuth.user.username
    );
    if (!aduserInfo_res.data) {
      this.$router.push({ name: "unauthorized" });
    }

    // only admins can view the categories
    if (!this.$GAUserAuth.isAdmin()) {
      //   console.log("base user");
      this.$router.push({ name: "unauthorized" });
    }
  },
};
</script>
